import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateTimeToPlainFormat } from '@/utils'

export interface CollectionMemo {
  id: number
  collectionNo: string
  holdingBranchCode: SystemCode
  callNumber: string
  shelfType: SystemCode
  collectionType: SystemCode
  status: SystemCode
  handlingType: SystemCode
  appendixCode: SystemCode
  updatedTime: string
  updatedBranchCode: SystemCode
  forwardingBranchCode: SystemCode
  userId: string
  workMemo: string
  workMemoTime: string
  workMemoBranchCode: SystemCode
  displayMemo: string
  displayMemoTime: string
  displayMemoBranchCode: SystemCode
  localMemo: string
  localMemoTime: string
  localMemoBranchCode: SystemCode
  revision: number
}

export const defaultCollectionMemo = (): CollectionMemo => ({
  id: 0,
  collectionNo: '',
  holdingBranchCode: defaultSystemCode(),
  callNumber: '',
  shelfType: defaultSystemCode(),
  collectionType: defaultSystemCode(),
  status: defaultSystemCode(),
  handlingType: defaultSystemCode(),
  appendixCode: defaultSystemCode(),
  updatedTime: '',
  updatedBranchCode: defaultSystemCode(),
  forwardingBranchCode: defaultSystemCode(),
  userId: '',
  workMemo: '',
  workMemoTime: '',
  workMemoBranchCode: defaultSystemCode(),
  displayMemo: '',
  displayMemoTime: '',
  displayMemoBranchCode: defaultSystemCode(),
  localMemo: '',
  localMemoTime: '',
  localMemoBranchCode: defaultSystemCode(),
  revision: 0
})

export function CollectionMemoFromJSON(json: any): CollectionMemo {
  return {
    id: exists(json, 'id') ? json.id : 0,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    holdingBranchCode: exists(json, 'holding_branch_code')
      ? SystemCodeFromJSON(json.holding_branch_code)
      : defaultSystemCode(),
    callNumber: exists(json, 'call_number') ? json.call_number : '',
    shelfType: exists(json, 'shelf_type')
      ? SystemCodeFromJSON(json.shelf_type)
      : defaultSystemCode(),
    collectionType: exists(json, 'collection_type')
      ? SystemCodeFromJSON(json.collection_type)
      : defaultSystemCode(),
    status: exists(json, 'status')
      ? SystemCodeFromJSON(json.status)
      : defaultSystemCode(),
    handlingType: exists(json, 'handling_type')
      ? SystemCodeFromJSON(json.handling_type)
      : defaultSystemCode(),
    appendixCode: exists(json, 'appendix_code')
      ? SystemCodeFromJSON(json.appendix_code)
      : defaultSystemCode(),
    updatedTime: exists(json, 'updated_time')
      ? dateTimeToPlainFormat(json.updated_time)
      : '',
    updatedBranchCode: exists(json, 'updated_branch_code')
      ? SystemCodeFromJSON(json.updated_branch_code)
      : defaultSystemCode(),
    forwardingBranchCode: exists(json, 'forwarding_branch_code')
      ? SystemCodeFromJSON(json.forwarding_branch_code)
      : defaultSystemCode(),
    userId: exists(json, 'user_id') ? json.user_id : '',
    workMemo: exists(json, 'work_memo') ? json.work_memo : '',
    workMemoTime: exists(json, 'work_memo_time')
      ? dateTimeToPlainFormat(json.work_memo_time)
      : '',
    workMemoBranchCode: exists(json, 'work_memo_branch_code')
      ? SystemCodeFromJSON(json.work_memo_branch_code)
      : defaultSystemCode(),
    displayMemo: exists(json, 'display_memo') ? json.display_memo : '',
    displayMemoTime: exists(json, 'display_memo_time')
      ? dateTimeToPlainFormat(json.display_memo_time)
      : '',
    displayMemoBranchCode: exists(json, 'display_memo_branch_code')
      ? SystemCodeFromJSON(json.display_memo_branch_code)
      : defaultSystemCode(),
    localMemo: exists(json, 'local_memo') ? json.local_memo : '',
    localMemoTime: exists(json, 'local_memo_time')
      ? dateTimeToPlainFormat(json.local_memo_time)
      : '',
    localMemoBranchCode: exists(json, 'local_memo_branch_code')
      ? SystemCodeFromJSON(json.local_memo_branch_code)
      : defaultSystemCode(),
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
